import { PatientTitleProps } from "src/types/case";

export const DEFAULT_DRUG_NAME = "QUTENZA (capsaicin) 8% topical system";
export const DEFAULT_DRUG_ID = 119717;

export const PATIENT_TITLE: readonly PatientTitleProps[] = [
  {
    label: 'Mr.',
    value: 'mr',
  },
  {
    label: 'Ms.',
    value: 'ms',
  },
  {
    label: 'Mrs.',
    value: 'mrs',
  },
  {
    label: 'Miss',
    value: 'miss',
  },
];

export const PATIENT_GENDER: PatientTitleProps[] = [
  {
    label: 'M',
    value: 'M',
  },
  {
    label: 'F',
    value: 'F',
  },
];

export const PATIENT_TIME_TO_CONTACT: PatientTitleProps[] = [
  {
    label: 'Morning',
    value: 'morning',
  },
  {
    label: 'Afternoon',
    value: 'afternoon',
  },
  {
    label: 'Evening',
    value: 'evening',
  },
];

export const PATIENT_PHONE_TYPES: PatientTitleProps[] = [
  {
    label: 'Cell',
    value: 'cell',
  },
  {
    label: 'Home',
    value: 'home',
  },
  {
    label: 'Work',
    value: 'work',
  },
];

export const PATIENT_ADDR_TYPES: PatientTitleProps[] = [
  {
    label: 'Home',
    value: 'home',
  },
  {
    label: 'Work',
    value: 'work',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const PATIENT_INSURANCE_TYPE: PatientTitleProps[] = [
  {
    label: 'Self',
    value: 'self',
  },
  {
    label: 'Spouse',
    value: 'spouse',
  },
  {
    label: 'Guardian',
    value: 'guardian',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const PATIENT_SITE_TYPE: PatientTitleProps[] = [
  {
    label: 'Physician Office',
    value: 'office',
  },
  {
    label: 'Ambulatory Surgical Center',
    value: 'asc',
  },
  {
    label: 'Hospital Outpatient',
    value: 'hospital',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const PATIENT_PHARMACY_INSTRUCTIONS: PatientTitleProps[] = [
  {
    label: 'Initial Course - 5 Refills',
    value: 'standard'
  },
  {
    label:'Maintenance Course - 10 Refills',
    value: 'maintenance'
  },
  {
    label: 'Initial Course Bilateral - 5 Refills',
    value: 'bilateral'
  },
  {
    label: 'Bilateral Maintenance Course - 10 Refills',
    value: 'bilateral_maintenance',
  }
];

export const CASE_STATUS_LISTING: { label: string; value: string | boolean; }[] = [
  {
    label: 'All Cases',
    value: '',
  },
  {
    label: 'Active Cases',
    value: 'open',
  },
  {
    label: 'Closed Cases',
    value: 'closed',
  },
  {
    label: 'Transferred Cases',
    value: 'transferred'
  }
];

export const TREATMENT_STATUS_LISTING: { label: string; value: string | boolean; }[] = [
  {
    label: 'All Treatments',
    value: '',
  },
  {
    label: 'Active Treatments',
    value: true,
  },
  {
    label: 'Closed Treatments',
    value: false,
  },
];

export const CASE_HEADER_LISTING = [
  {
    value: 'id',
    label: 'ID',
  },
  {
    value: '',
    label: 'Ongoing',
  },
  {
    value: 'created_at',
    label: 'Submitted',
  },
  {
    value: 'investigated_at',
    label: 'Completed',
  },
  {
    value: '',
    label: 'Treated',
  },
  {
    value: '',
    label: 'Next Eligible Tmnt',
  },
  {
    value: 'patient_firstlastname',
    label: 'Patient',
  },
  {
    value: 'doctor_firstlastname',
    label: 'Physician',
  },
  {
    value: 'status_name',
    label: 'Status',
  },
  {
    value: '',
    label: 'Next Steps',
  },
  {
    value: '',
    label: 'Actions',
  },
  {
    value: '',
    label: 'FAM/Office Note',    
  }
];

export const TREATMENT_HEADER_LISTING = [
  {
    value: 'id',
    label: 'Case ID',
  },
  {
    value: '',
    label: 'Instillation',
  },
  {
    value: '',
    label: 'Ordered'
  },
  {
    value: '',
    label: 'Delivery ETA',
  },
  {
    value: '',
    label: 'Patient',
  },
  {
    value: '',
    label: 'Provider',
  },
  {
    value: '',
    label: 'Treatment Status',
  },
  {
    value: '',
    label: 'Next Steps',
  },
];

export const ACTION_DASHBOARD_COVERAGE_AVAILABLE_HEADER_LISTING = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID'
  },
  {
    value: '',
    label: 'Reverification',
  },
  {
    value: '',
    label: 'BI Completed',
  },
  {
    value: '',
    label: 'Insurance Type',
  },
  {
    value: '',
    label: 'Physician',
  },
  {
    value: '',
    label: 'Coverage Status',
  },
  {
    value: '',
    label: 'Provide Treatment Status',
  },
  {
    value: '',
    label: 'Coverage Status',
  },
  {
    value: '',
    label: 'Provide Patient Status',
  },
];

export const ACTION_DASHBOARD_TRANSFERED_TO_SPECIALITY_PHARMACY_HEADER_LISTING = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID'
  },
  {
    value: '',
    label: 'Provider',
  },
  {
    value: '',
    label: 'Pharmacy (SP) Status)',
  },
  {
    value: '',
    label: 'Provide Treatment Status',
  },
  {
    value: '',
    label: 'SP Transferred To',
  },
  {
    value: '',
    label: 'Date Transferred',
  },
  {
    value: '',
    label: 'Status Update',
  },
  {
    value: '',
    label: 'Date Shipped',
  },
  {
    value: '',
    label: 'Carrier',
  },
  {
    value: '',
    label: 'Tracking Number',
  },
];

export const ACTION_DASHBOARD_PENDING_HEADER_LISTING = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID'
  },
  {
    value: '',
    label: 'Reverification',
  },
  {
    value: '',
    label: 'BI Submitted',
  },
  {
    value: '',
    label: 'BI Completed',
  },
  {
    value: '',
    label: 'Primary Insurance Type',
  },
  {
    value: '',
    label: 'Provider',
  },
  {
    value: '',
    label: 'Medical Status',
  },
  {
    value: '',
    label: 'Provide Treatment Status',
  },
  {
    value: '',
    label: 'Pharmacy Status',
  },
  {
    value: '',
    label: 'Provide Treatment Status',
  },
];

export const ACTION_DASHBOARD_ACTION_REQUIRED_HEADER_LISTING = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID'
  },
  {
    value: '',
    label: 'Reverification',
  },
  {
    value: '',
    label: 'BI Completed',
  },
  {
    value: '',
    label: 'Insurance Type',
  },
  {
    value: '',
    label: 'Physician',
  },
  {
    value: '',
    label: 'Coverage Status',
  },
  {
    value: '',
    label: 'Next Step',
  },
  {
    value: '',
    label: 'Coverage Status',
  },
  {
    value: '',
    label: 'Next Step',
  },
];

export const ORDER_HEADER_LISTING = [
  {
    value: 'id',
    label: 'ID',
  },
  {
    value: '',
    label: 'Case ID',
  },
  {
    value: '',
    label: 'Customer PO',
  },
  {
    value: '',
    label: 'Ordered By',
  },
  {
    value: '',
    label: 'Ordered Date',
  },
  {
    value: '',
    label: 'Completed Date',
  },
  {
    value: '',
    label: 'Status',
  },
];

export const NOT_TREATING_REASON = [
  {
    value: "HCP Decided Not To Treat",
    label: "HCP Decided Not To Treat",
    subReasons: [
      {
        value: "Cost to Patient",
        label: "Cost to Patient",
      },
      {
        value: "Trying Other Medications",
        label: "Trying Other Medications",
      },
      {
        value: "Decided to Try Device",
        label: "Decided to Try Device",
      },
      {
        value: "Unable to Reach Patient",
        label: "Unable to Reach Patient",
      },
      {
        value: "Office Has Not Integrated QTZ Into Practice",
        label: "Office Has Not Integrated QTZ Into Practice",
      },
      {
        value: "Patient Not Interested",
        label: "Patient Not Interested",
      },
      {
        value: "Clinical Reason",
        label: "Clinical Reason",
      },
      {
        value: "Treatment on Hold",
        label: "Treatment on Hold",
      },
      {
        value: "Patient Referred Out",
        label: "Patient Referred Out",
      },
    ]
  },
  {
    value: "Patient No Longer with Practice",
    label: "Patient No Longer with Practice",
    subReasons: []
  },
  {
    value: "Patient Deceased",
    label: "Patient Deceased",
    subReasons: []
  },
   {
    value: "Patient Decline Treatment",
    label: "Patient Decline Treatment",
    subReasons: []
  },
  {
    value: "Patient Unreachable",
    label: "Patient Unreachable",
    subReasons: []
  },
  {
    value: "Preferred Acquisition Method Not Available",
    label: "Preferred Acquisition Method Not Available",
    subReasons: [
      {
        value: "Office Prefers SP (SP not available)",
        label: "Office Prefers SP (SP not available)",
      },
      {
        value: "Office Prefers B&B (B&B not available)",
        label: "Office Prefers B&B (B&B not available)",
      },
      {
        value: "Office Prefers Alternative Site of Care (ASOC Not Available)",
        label: "Office Prefers Alternative Site of Care (ASOC Not Available)",
      },
    ]
  },
  {
    value: "Insurance Coverage Not Available",
    label: "Insurance Coverage Not Available",
    subReasons: [
      {
        value: "Insurance Doesn't Cover QTZ",
        label: "Insurance Doesn't Cover QTZ",
      },
      {
        value: "Patient Doesn't Meet PA or Step-Edit Requirements",
        label: "Patient Doesn't Meet PA or Step-Edit Requirements",
      },
      {
        value: "PA Submitted & Denied",
        label: "PA Submitted & Denied",
      },
      {
        value: "Appeal Submitted & Denied",
        label: "Appeal Submitted & Denied",
      },
    ],
  },
  {
    value: "BI Expired - Request for Reverification Submitted",
    label: "BI Expired - Request for Reverification Submitted",
    subReasons: []
  },
];

export const COLOR_LIST = [
  "#7cb5ec","#434348","#90ed7d","#f7a35c","#8085e9","#f15c80","#e4d354","#2b908f","#f45b5b","#91e8e1"
]
export const EOBs_TABLE_HEADER = [
  {
    value: 'insurance_name',
    label: 'Insurance',
  },
  {
    value: 'insurance_type',
    label: 'Type',
  },
  {
    value: 'insurance_state',
    label: 'Office State',
  },
   {
    value: 'insurance_group',
    label: 'Plan State',
  },
  {
    value: 'speciality',
    label: 'Specialty',
  },
  {
    value: 'insurance_mac',
    label: 'MAC',
  },
  {
    value: 'cpt_codes',
    label: 'CPT',
  },
  {
    value: 'service_date',
    label: 'Service Date',
  },
 
  {
    value: '',
    label: 'Actions',
  },
];

export const DOCUMENT_LISTING_HEADER = [
  {
    value: 'case_id',
    label: 'Case',
  },
  {
    value: 'category',
    label: 'Category',
  },
  {
    value: 'filename',
    label: 'File Name',
  },
  {
    value: 'size_in_kb',
    label: 'Size',
  },
  {
    value: 'created_at',
    label: 'Upload Date',
  },
]
